import { jaguarsharkAppId } from '../constants/keys';
// TODO: this notSupportedAppIds and notSupportedActionTypes will come from ECS feature setting
var notSupportedAppIds = [];
var notSupportedActionTypes = [
    'invokeAPI',
    'invokeBot',
    'openTaskpane',
];
// Functions used to contol if an action is supported or not based on ECS feature settings and flights.
// TODO: Could add more granular control like isSupportedActionType, isSupportedActionTypeByApp. Not finalized yet.
export var isSupportedApp = function (appId, featureGates) {
    if (appId === jaguarsharkAppId) {
        return featureGates.testAppActionEnabled;
    }
    return !notSupportedAppIds.includes(appId);
};
export var isSupportedActionType = function (actionType) {
    return !notSupportedActionTypes.includes(actionType);
};
//# sourceMappingURL=mosAppActionGates.js.map